/**
 * Contract enforced on every feedback payload before submission.
 * All feedback types (user_feedback, account_deletion, etc.) must include
 * feedback_type and profile_id, checked wiht @Vladimir Polák on documentation.
 */
export function assertFeedbackContract(payload) {
  if (!payload.feedback_type) {
    this.handleError({ error: "[FeedbackContract] payload must include feedback_type", code: ''});
  }
  if (!payload.profile_id) {
    this.handleError({ error: "[FeedbackContract] payload must include profile_id", code: ''});
  }
}
